
import React from 'react'
import { Slide, toast as toastOG, type ToastOptions } from 'react-toastify'
import { CheckCircle, CircleAlert, InfoIcon } from 'lucide-react'
import classNames from 'classnames'

import Text from '@/elements/Text'

import './Toast.scss'
import type { ColorVariant } from '../theme'

const baseOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  transition: Slide,
  draggable: true,
  pauseOnHover: false,
  icon: false,
  closeButton: true,
  hideProgressBar: true,
}

type ToastType = 'info' | 'success' | 'error'

const toastConfig: Record<ToastType, {
  icon: React.ElementType,
  color: ColorVariant
  defaultTitle: string,
  className: string,
}> = {
  info: {
    icon: InfoIcon,
    color: 'primary',
    defaultTitle: 'Info',
    className: 'toast info',
  },
  success: {
    icon: CheckCircle,
    color: 'green',
    defaultTitle: 'Success',
    className: 'toast success',
  },
  error: {
    icon: CircleAlert,
    color: 'red',
    defaultTitle: 'Error',
    className: 'toast error',
  },
}

function showToast(
  type: ToastType,
  description?: string,
  title?: string,
  outerWrapper?: boolean,
  options?: ToastOptions
) {
  const { icon: Icon, color, defaultTitle, className } = toastConfig[type]
  return toastOG(
    <div>
      <div className='toast-title'>
        <Icon size={18} />
        <Text variant='h4' color={color}>{title || defaultTitle}</Text>
      </div>
      <Text color='black-light-40'>{description}</Text>
    </div>,
    {
      ...baseOptions,
      ...options,
      type,
      className: classNames(className, { 'outer-wrapper': outerWrapper })
    }
  )
}

const toast = {
  info: (description?: string, title?: string, outerWrapper?: boolean, options?: ToastOptions) =>
    showToast('info', description, title, outerWrapper, options),
  success: (description?: string, title?: string, outerWrapper?: boolean, options?: ToastOptions) =>
    showToast('success', description, title, outerWrapper, options),
  error: (description?: string, title?: string, outerWrapper?: boolean, options?: ToastOptions) =>
    showToast('error', description, title, outerWrapper, options),
}

export default toast
